import { networkClient } from './client';
import type { ApiEnvelope } from './types';

export interface LeaderboardEntry {
  team_id: string;
  team_name: string;
  user_id: string;
  user_display_name: string;
  total_points: number;
  gameweek_points?: number;
  matchday_points?: number;
  average_points: number;
  team_rank: number;
  booster_used: boolean;
}

export interface LeaderboardData {
  tournament_calendar_id: string;
  league_id?: string;
  type: 'gameweek' | 'matchday';
  from_gameweek?: number;
  to_gameweek?: number;
  from_matchday?: number;
  to_matchday?: number;
  entries: LeaderboardEntry[];
  user_position: LeaderboardEntry | null;
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
  last_updated: string;
}

export type LeaderboardResponse = ApiEnvelope<LeaderboardData>;

export interface FetchLeaderboardParams {
  tournament_calendar: string;
  type: 'gameweek' | 'matchday';
  league_id?: string;
  upto_gameweek_id?: string;
  upto_matchday_id?: string;
  limit?: number;
  offset?: number;
}

export const fetchLeaderboard = (params: FetchLeaderboardParams): Promise<LeaderboardResponse> =>
  networkClient
    .get<LeaderboardResponse>('/api/fantasy-teams/leaderboard', { params })
    .then(({ data }) => data);

export interface LeaderboardPeriod {
  id: string;
  number: number;
  name: string;
  status: string;
}

export interface LeaderboardPeriodsData {
  tournament_calendar_id: string;
  type: 'gameweek' | 'matchday';
  periods: LeaderboardPeriod[];
}

export type LeaderboardPeriodsResponse = ApiEnvelope<LeaderboardPeriodsData>;

export const fetchLeaderboardPeriods = (
  tournamentCalendarId: string,
  includeAll: boolean = false
): Promise<LeaderboardPeriodsResponse> =>
  networkClient
    .get<LeaderboardPeriodsResponse>('/api/fantasy-teams/leaderboard/periods', {
      params: { tournament_calendar: tournamentCalendarId, include_all: includeAll },
    })
    .then(({ data }) => data);

export const fetchCurrentTournamentCalendar = (): Promise<
  ApiEnvelope<{
    id: string;
    competition_name: string | null;
    season_label: string | null;
  } | null>
> => networkClient.get('/api/league/tournament-calendars/current').then(({ data }) => data);
